import React from 'react';
import { connect } from 'react-redux';

import { closeDrawer } from '../../../slices/accounts/video/management';
import { ManageMinutesDrawer } from '../ManageMinutesDrawer';
import { RootState } from '../../../slices/rootReducer';
import { selectIsDrawerOpen } from '../../../slices/accounts/video/management/selectors';
import { selectors as authSelectors } from '../../../slices/auth';

interface IMapStateToProps {
  isAdmin: boolean;
  isDrawerOpen: boolean;
}

interface IMapDispatchProps {
  closeDrawer: typeof closeDrawer;
}

type Props = IMapStateToProps & IMapDispatchProps;

class DrawerLauncherBase extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.handleCloseManageMinutesDrawer = this.handleCloseManageMinutesDrawer.bind(this);
  }

  private handleCloseManageMinutesDrawer() {
    this.props.closeDrawer();
  }

  render() {
    return (
      <>
        { this.props.isDrawerOpen && <ManageMinutesDrawer onModalClose={this.handleCloseManageMinutesDrawer} /> }
      </>
    );
  }

}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  const isAdmin = authSelectors.isAuthUserSightxAdmin(state);
  const isDrawerOpen = selectIsDrawerOpen(state);
  return {
    isAdmin,
    isDrawerOpen
  };
};

const mapDispatchToProps: IMapDispatchProps = {
  closeDrawer
};

const DrawerLauncher = connect(mapStateToProps, mapDispatchToProps)(DrawerLauncherBase);

export { DrawerLauncher };
